// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AXcXY{display:flex;flex-direction:column;gap:.75rem;min-width:18rem}.vfZyw{color:var(--description-popup-title-color);font-size:.95em;font-weight:700;letter-spacing:.05em;margin-bottom:.25rem;text-transform:uppercase}.oeLGW{display:flex;flex-direction:column;gap:.25rem}.GgDtq{align-items:center;display:flex;font-size:1.1em;font-weight:700;gap:.5rem}.GgDtq i.icon{margin:0;transform:translateY(-2px)}.FmrZR{color:var(--anchore-color-blue-600)}.Uq0uV{color:var(--anchore-color-purple-600)}.xlZJz{color:var(--anchore-color-gray-500)}.gjGfV{font-size:.95em;line-height:1.35}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `AXcXY`,
	"title": `vfZyw`,
	"row": `oeLGW`,
	"statusLabel": `GgDtq`,
	"primary": `FmrZR`,
	"secondary": `Uq0uV`,
	"muted": `xlZJz`,
	"detail": `gjGfV`
};
module.exports = ___CSS_LOADER_EXPORT___;
